import React from "react";
import { normalizeImageUrl } from "@/lib/imageUrl";

// Clean logo renderer with an initials fallback when no logo is uploaded.
function initials(name) {
  const words = (name || "").replace(/[^A-Za-z0-9 ]/g, "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "?";
  const stop = new Set(["of", "the", "and", "at"]);
  const keep = words.filter((w) => !stop.has(w.toLowerCase()));
  const src = keep.length ? keep : words;
  return src.slice(0, 2).map((w) => w[0].toUpperCase()).join("");
}

const SIZES = { sm: "w-8 h-8 text-[10px]", md: "w-12 h-12 text-xs", lg: "w-16 h-16 text-sm", xl: "w-20 h-20 text-base" };

export default function SchoolLogo({ name, logoUrl, darkLogoUrl, dark = false, size = "md", className = "", testid }) {
  const [errored, setErrored] = React.useState(false);
  React.useEffect(() => { setErrored(false); }, [logoUrl, darkLogoUrl]);
  const url = dark ? (darkLogoUrl || logoUrl) : (logoUrl || darkLogoUrl);
  const box = SIZES[size] || SIZES.md;

  if (url && !errored) {
    return (
      <div data-testid={testid} className={`${box} shrink-0 rounded-sm overflow-hidden bg-white border border-slate-200 grid place-items-center ${className}`}>
        <img src={normalizeImageUrl(url)} alt={name || "School"} className="w-full h-full object-contain p-1" onError={() => setErrored(true)} />
      </div>
    );
  }
  return (
    <div data-testid={testid} title={name || ""}
      className={`${box} shrink-0 rounded-sm grid place-items-center font-display font-semibold tracking-tight ${dark ? "bg-white/10 text-white" : "bg-[#0A192F] text-white"} ${className}`}>
      {initials(name)}
    </div>
  );
}
